var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSafeBoxOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.4 3.5H11.6C12.7449 3.5 13.5133 3.50117 14.105 3.54952C14.6793 3.59643 14.9539 3.6802 15.135 3.77248C15.6054 4.01217 15.9878 4.39462 16.2275 4.86502C16.3198 5.04615 16.4036 5.32071 16.4505 5.89496C16.4988 6.48671 16.5 7.25514 16.5 8.4V9.13784C16.5 10.2827 16.4988 11.0511 16.4505 11.6429C16.4036 12.2171 16.3198 12.4917 16.2275 12.6728C15.9878 13.1432 15.6054 13.5257 15.135 13.7654C14.9539 13.8576 14.6793 13.9414 14.105 13.9883C13.5133 14.0367 12.7449 14.0378 11.6 14.0378H8.4C7.25514 14.0378 6.48671 14.0367 5.89496 13.9883C5.32071 13.9414 5.04615 13.8576 4.86502 13.7654C4.39462 13.5257 4.01217 13.1432 3.77248 12.6728C3.6802 12.4917 3.59643 12.2171 3.54952 11.6429C3.50117 11.0511 3.5 10.2827 3.5 9.13784V8.4C3.5 7.25514 3.50117 6.48671 3.54952 5.89496C3.59643 5.32071 3.6802 5.04615 3.77248 4.86502C4.01217 4.39462 4.39462 4.01217 4.86502 3.77248C5.04615 3.6802 5.32071 3.59643 5.89496 3.54952C6.48671 3.50117 7.25514 3.5 8.4 3.5ZM2 8.4C2 6.15979 2 5.03969 2.43597 4.18404C2.81947 3.43139 3.43139 2.81947 4.18404 2.43597C5.03969 2 6.15979 2 8.4 2H11.6C13.8402 2 14.9603 2 15.816 2.43597C16.5686 2.81947 17.1805 3.43139 17.564 4.18404C18 5.03969 18 6.15979 18 8.4V9.13784C18 11.3781 18 12.4982 17.564 13.3538C17.1805 14.1065 16.5686 14.7184 15.816 15.1019C14.9603 15.5378 13.8402 15.5378 11.6 15.5378H8.4C6.15979 15.5378 5.03969 15.5378 4.18404 15.1019C3.43139 14.7184 2.81947 14.1065 2.43597 13.3538C2 12.4982 2 11.3781 2 9.13784V8.4ZM12.6779 11.2734C12.6779 11.6877 13.0137 12.0234 13.4279 12.0234C13.8421 12.0234 14.1779 11.6877 14.1779 11.2734L14.1779 6.14572C14.1779 5.73151 13.8421 5.39572 13.4279 5.39572C13.0137 5.39572 12.6779 5.73151 12.6779 6.14572L12.6779 11.2734Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 16.4904C14 17.3188 13.3284 17.9904 12.5 17.9904L7.5 17.9904C6.67157 17.9904 6 17.3188 6 16.4904L14 16.4904Z",
  fill: "currentColor"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 6.00269,
  y: 6.14258,
  width: 2,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 6.00269,
  y: 9.14258,
  width: 2,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 9.00269,
  y: 6.14258,
  width: 2,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 9.00269,
  y: 9.14258,
  width: 2,
  height: 2,
  rx: 1,
  fill: "currentColor"
})));
export { SvgSafeBoxOutline20 as ReactComponent };